import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createVideoAllocation,
  deleteVideoAllocation,
  getVideoAllocations,
} from "data/server_apis/adsService";

const adsVideoAllocationAdapter = createEntityAdapter({
  selectId: (allocation) => allocation.id,
});

export const getVideoAllocationsThunk = createAsyncThunk(
  "ads/getVideoAllocations",
  async (id, { rejectWithValue }) => {
    try {
      return (await getVideoAllocations(id)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const createVideoAllocationThunk = createAsyncThunk(
  "ads/createVideoAllocation",
  async (data, { rejectWithValue }) => {
    try {
      return (await createVideoAllocation(data)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const deleteVideoAllocationThunk = createAsyncThunk(
  "ads/deleteVideoAllocation",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteVideoAllocation(id)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const adsVideoAllocationAllocationSlice = createSlice({
  name: "adsVideoAllocationAllocation",
  initialState: adsVideoAllocationAdapter.getInitialState({
    loading: {},
    error: {},
    errorMessage: {},
    success: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createVideoAllocationThunk.pending, (state, action) => {
        state.loading = { create: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(createVideoAllocationThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { create: true };
        state.success = {};
        state.errorMessage = { create: action.payload?.message };
      })
      .addCase(createVideoAllocationThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { create: true };
        state.errorMessage = {};
        adsVideoAllocationAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(getVideoAllocationsThunk.pending, (state, action) => {
        state.loading = { list: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(getVideoAllocationsThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { list: true };
        state.success = {};
        state.errorMessage = { list: action.payload?.message };
      })
      .addCase(getVideoAllocationsThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { list: true };
        state.errorMessage = {};
        adsVideoAllocationAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(deleteVideoAllocationThunk.pending, (state, action) => {
        state.loading = { delete: action.meta.arg };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(deleteVideoAllocationThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { delete: true };
        state.success = {};
        state.errorMessage = { delete: action.payload?.message };
      })
      .addCase(deleteVideoAllocationThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { delete: true };
        state.errorMessage = {};
        adsVideoAllocationAdapter.removeOne(state, action.meta.arg);
      });
  },
});

export const adsVideoAllocationSelector =
  adsVideoAllocationAdapter.getSelectors((state) => state.adsVideoAllocation);

export const {} = adsVideoAllocationAllocationSlice.actions;

export default adsVideoAllocationAllocationSlice.reducer;
